/**
 * Сервис авторизации
 */
import {Tool} from "../helpers/Tool";

export default class AuthService
{
    static readonly userTokenName: string = 'user_auth_token';

    static userToken: string|null = null;

    /**
     * Записать в хранилище токен пользователя
     * @param token
     * @param date
     */
    static setUserToken(token: string, date: Date|null): void
    {
        this.userToken = token;
        Tool.setCookie(this.userTokenName, token, date);
    }

    /**
     * Получить из хранилища токен клиента
     */
    static getUserToken(): string|null
    {
        if (!this.userToken) {
            this.userToken = typeof Tool.getCookie(this.userTokenName) !== 'undefined'
                ? (Tool.getCookie(this.userTokenName) as string)
                : null;
        }
        return this.userToken;
    }
}
